export default __webpack_public_path__ + "static/media/Bajaj-Allianz-Life-Insurance-Logo.b4d78587.svg";